const systemPrefix = 'system_'

// eslint-disable-next-line import/prefer-default-export
export const systemFlags = {
    LOADING: `${systemPrefix}LOADING`,
}
